import { isEmpty } from 'lodash';

import {
    REQUEST_UPDATE_PROFILE,
    SUCCESS_UPDATE_PROFILE,
    FAILURE_UPDATE_PROFILE,
    RESET_FORM_SUBMIT_UPDATE_PROFILE,
    REQUEST_USER_INFO,
    SUCCESS_USER_INFO,
    FAILURE_USER_INFO,
    REQUEST_SAVE_COORDINATES,
    SUCCESS_SAVE_COORDINATES,
    FAILURE_SAVE_COORDINATES,
    SET_TIMEOUT_ID,
    CLEAR_TIMEOUT_ID
} from './constants';
import { HTTP_METHOD_GET, HTTP_METHOD_PUT } from '../../../constants/httpMethod';

import { updateInfos } from '../../account/actions';

import { makeActionCreator } from '../../../utils/actionsUtils';

import { CALL_API } from '../../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_UPDATE_PROFILE);

export const setTimeoutId = makeActionCreator(SET_TIMEOUT_ID, 'timeoutId');
export const clearTimeoutId = makeActionCreator(CLEAR_TIMEOUT_ID);

export function sendProfileUpdateRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/user/update',
            method: HTTP_METHOD_PUT,
            body: formData,
            types: [REQUEST_UPDATE_PROFILE, SUCCESS_UPDATE_PROFILE, FAILURE_UPDATE_PROFILE],
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload));
                if (callback) {
                    callback();
                }
            }
        }
    };
}

export function saveUserCoordinates(coordinates) {
    return {
        [CALL_API]: {
            endpoint: '/user/coordinates',
            method: HTTP_METHOD_PUT,
            body: coordinates,
            types: [REQUEST_SAVE_COORDINATES, SUCCESS_SAVE_COORDINATES, FAILURE_SAVE_COORDINATES],
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload));
            }
        }
    };
}

export function fetchUserInfo() {
    return {
        [CALL_API]: {
            endpoint: '/user',
            method: HTTP_METHOD_GET,
            types: [REQUEST_USER_INFO, SUCCESS_USER_INFO, FAILURE_USER_INFO],
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload));
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/myprofile/actions.js